import {
    EVENT_CREATE_REQUEST,
    EVENT_CREATE_SUCCESS,
    EVENT_CREATE_FAIL,
    EVENT_CREATE_CLEAR,
    EVENT_LIST_REQUEST,
    EVENT_LIST_SUCCESS,
    EVENT_LIST_FAIL,
    EVENT_UNREAD_COUNT_REQUEST,
    EVENT_UNREAD_COUNT_SUCCESS,
    EVENT_UNREAD_COUNT_FAIL,
    EVENT_MARK_READ_SUCCESS,
    EVENT_DELETE_REQUEST,
    EVENT_DELETE_SUCCESS,
    EVENT_DELETE_FAIL,
    EVENT_DELETE_CLEAR
} from '../constants/eventConstant'

export const createEventReducer = (state = {}, action) => {
    switch(action.type) {
        case EVENT_CREATE_REQUEST:
            return { loading: true, error: null }
        case EVENT_CREATE_SUCCESS:
            return { loading: false, error: null, message: action.payload, success: true }
        case EVENT_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case EVENT_CREATE_CLEAR:
            return { loading: false, error: null, message: null, success: null }
        default:
            return state
    }
}

export const listEventsReducer = (state = {}, action) => {
    switch(action.type) {
        case EVENT_LIST_REQUEST:
            return { loading: true, error: null }
        case EVENT_LIST_SUCCESS:
            return {
                loading: false,
                error: null,
                events: action.payload.events,
                count: action.payload.eventsCounts,
                page: action.payload.page
            }
        case EVENT_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const eventUnreadCountReducer = (state = { count: 0 }, action) => {
    switch(action.type) {
        case EVENT_UNREAD_COUNT_REQUEST:
            return { ...state, loading: true, error: null }
        case EVENT_UNREAD_COUNT_SUCCESS:
            return { loading: false, error: null, count: action.payload }
        case EVENT_MARK_READ_SUCCESS:
            return { loading: false, error: null, count: 0 }
        case EVENT_UNREAD_COUNT_FAIL:
            return { ...state, loading: false, error: action.payload }
        default:
            return state
    }
}

export const deleteEventReducer = (state = {}, action) => {
    switch(action.type) {
        case EVENT_DELETE_REQUEST:
            return { loading: true, error: null }
        case EVENT_DELETE_SUCCESS:
            return { loading: false, error: null, message: action.payload, success: true }
        case EVENT_DELETE_FAIL:
            return { loading: false, error: action.payload }
        case EVENT_DELETE_CLEAR:
            return { loading: false, error: null, message: null, success: null }
        default:
            return state
    }
}
